import { useState } from "react";

export type ScoreId = number;

export type ScoresIdsState = {
    setScoresIds: (scoresIds: ScoreId[] | undefined) => void;
};

type ScoresIdsParams = {
    query: ScoreId[] | undefined;
    state: ScoresIdsState;
};
export const useScoresIds = (initScoresIds?: ScoreId[]): ScoresIdsParams => {
    const [scoresIds, setScoresIds] = useState<ScoreId[] | undefined>(initScoresIds);

    return {
        query: scoresIds,
        state: {
            setScoresIds,
        },
    };
};
